// components/MobileHeader.tsx
import React from 'react';
import { FaRoute, FaPlus, FaBars } from 'react-icons/fa';

interface MobileHeaderProps {
  onAddDestination: () => void;
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  onAddDestination,
  onToggleSidebar,
  isSidebarOpen,
}) => {
  return (
    <div className="bg-white shadow-md p-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <button
          onClick={onToggleSidebar}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <FaBars className="text-gray-700 text-xl" />
        </button>
        <FaRoute className="text-blue-500 text-xl" />
        <h1 className="text-sm font-bold text-gray-800">Route Optimizer</h1>
      </div>
      <button
        onClick={onAddDestination}
        className="px-3 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-xs font-medium flex items-center gap-1"
      >
        <FaPlus /> Add
      </button>
    </div>
  );
};